import ExchangeList from "../../components/ExchangeList";

function Index() {
  return (
    <ExchangeList instrument={`index`} />
  );
}

export default Index;
